import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for add group account
export const AddGroupAccount = createSlice({
  name: "AddGroupAccount",
  initialState: {
    api_completed: false,
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    switchResponse: false,
    data: [],
  },
  reducers: {
    add_AddGroupAccount: (state, _) => {
      state.isLoading = true;
    },
    success_api_call_add_AddGroupAccount: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
      state.isFirst = true;
      state.switchResponse = true;
    },
    failure_api_call_add_AddGroupAccount: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isSuccess = false;
      state.api_completed = true;
      state.switchResponse = true;
    },
    add_AddGroupAccount_is_success: (state, action) => {
      state.isSuccess = false;
    },
    create_AddGroupAccount_complete_api: (state, action) => {
      state.api_completed = false;
    },
    false_switchGroupadd_response: (state) => {
      state.switchResponse = false;
    },
  },
});
export default AddGroupAccount.reducer;
export const {
  add_AddGroupAccount,
  success_api_call_add_AddGroupAccount,
  failure_api_call_add_AddGroupAccount,
  create_AddGroupAccount_complete_api,
  add_AddGroupAccount_is_success,
  false_switchGroupadd_response,
} = AddGroupAccount.actions;
